import { getReq, createUrl } from "@/infra/http";
import { BaseResponseModel } from "@/models/core.model";
import { ThirdPartyType } from "@/models/third-party-account.model";

export const hasUserThirdPartyAccount = async (userId: number, type: ThirdPartyType)
  : Promise<BaseResponseModel<boolean>> => {
  return await getReq(createUrl(`a/ThirdParty/HasUserThirdPartyAccount`),
  {params: {userId, type}}
  ).then((res: any) => res.data);
};
